// Timeline data based on the uploaded screenshots
const timelineData = [
        {
        id: 1,
        title: 'Senior Software Engineer',
        isRemote: false,
        isHybrid: true,
        company: 'Dialogue',
        location: 'Montréal, Canada',
        startDate: '2025-10',
        description: 'Senior level part of Platform Team, focus on platform architecture & engineer toolings.',
        skills: [
            'Designing, building, and maintaining distributed backend services in Python',
            'Working with AWS to ensure scalability and reliability',
            'Contributing to internal platform tooling, orchestration workflows and data pipelines with Airflow & Snowflake',
            'Defining infrastructure as code with Terraform and improving CI/CD processes'
        ],
        category: 'work',
        image_url: 'https://media.licdn.com/dms/image/v2/C4D0BAQHqbANaCNWpLA/company-logo_200_200/company-logo_200_200/0/1630576725073/dialogue_md_logo?e=2147483647&v=beta&t=6jiZcyMya__GkxDGyT14WB4oxSQvKmSDv7dwcRzt02A'
    },
    {
        id: 2,
        title: 'Software Engineer, L3',
        isRemote: true,
        isHybrid: false,
        company: 'Fieldwire by Hilti',
        location: 'San Francisco, California, United States',
        startDate: '2024-01',
        endDate: '2025-05',
        description: 'L3 level Software engineer responsible for architecting and implementing complex integration systems.',
        skills: [
            'Architected near real-time integration system for Google Drive and SharePoint, enabling automatic document detection and processing',
            'Developed robust error handling mechanisms reducing integration failures and eliminating data loss scenarios',
            'Engineered high-performance document processing pipeline capable of handling complex file operations for 100,000+ files',
            'Led cross-functional collaboration with product, design, and QA teams to deliver complex integration features on time',
            'Worked remotely with international teams across multiple time zones - Experience with distributed team coordination'
        ],
        category: 'work',
        image_url: 'https://media.licdn.com/dms/image/v2/C4E0BAQHaCVEgv5uR5Q/company-logo_400_400/company-logo_400_400/0/1668619543921/fieldwirelabs_logo?e=2147483647&v=beta&t=BHP1EOkdhuvbLLc-RrUFphgUyMyNZzOcuQjsvkd1drQ'
    },
    {
        id: 3,
        title: 'Software Engineer, L2',
        isRemote: true,
        isHybrid: false,
        company: 'Fieldwire by Hilti',
        location: 'San Francisco, California, United States',
        startDate: '2022-05',
        endDate: '2024-01',
        description: 'L2 level software engineer focused on backend systems and integration development.',
        skills: [
            'Improved document processing quality by 90% through optimizing image processing algorithms and implementing intelligent error recovery',
            'Designed and built bidirectional file synchronization system between Fieldwire and SharePoint for enterprise customers',
            'Optimized database queries and implemented caching strategies across PDF export operations',
            'Resolved critical production issues related to OAuth authentication and file synchronization',
            'Participated in architecture decision reviews and knowledge-sharing sessions, contributing to technical excellence culture'
        ],
        category: 'work',
        image_url: 'https://media.licdn.com/dms/image/v2/C4E0BAQHaCVEgv5uR5Q/company-logo_400_400/company-logo_400_400/0/1668619543921/fieldwirelabs_logo?e=2147483647&v=beta&t=BHP1EOkdhuvbLLc-RrUFphgUyMyNZzOcuQjsvkd1drQ'
    },
    {
        id: 4,
        title: 'Software Engineer',
        isRemote: true,
        isHybrid: false,
        company: 'Teazit',
        location: 'Lyon, France',
        startDate: '2021-03',
        endDate: '2022-04',
        description: 'Full-stack software engineer specializing in video processing and streaming platforms.',
        skills: [
            'Engineered full-stack VOD management system with Python/Django backend and VueJS frontend for professional video processing',
            'Built multi-platform live streaming service supporting simultaneous broadcasts to 5+ destinations (Facebook, Instagram, Twitch + custom feeds)',
            'Implemented video clipping engine with frame-accurate extraction and custom encoding profiles',
            'Maintained and optimized Django ORM queries, reducing dashboard load times for power users',
        ],
        category: 'work',
        image_url: 'https://cdn.jaimelesstartups.fr/wp-content/uploads/2019/06/illustration%20%C3%A0%20propos%20de%20la%20startup%20Teazit.jpg'
    },
    {
        id: 5,
        title: 'Data Scientist',
        isRemote: false,
        isHybrid: true,
        company: 'Infotel',
        location: 'Blagnac, France',
        startDate: '2020-02',
        endDate: '2020-07',
        description: 'Data science internship focused on predictive analytics and machine learning solutions.',
        skills: [
            'Developed predictive analytics solution forecasting event outcomes using Python and scikit-learn',
            'Implemented data preprocessing pipeline that reduced analysis time while improving data quality',
            'Collaborated with business stakeholders to translate complex statistical findings into actionable business intelligence',
            'Technologies: Python, scikit-learn, pandas, NumPy, SQL, Data visualization'
        ],
        category: 'internship',
        image_url: 'https://s3-symbol-logo.tradingview.com/infotel--600.png'
    },
    {
        id: 6,
        title: 'Web Developer',
        isRemote: false,
        isHybrid: false,
        company: 'Etendards LTD',
        location: 'London, United Kingdom',
        startDate: '2018-09',
        endDate: '2019-02',
        description: 'International internship experience developing web applications for UK-based clients.',
        skills: [
            'Built full-stack web application with responsive frontend and RESTful backend architecture for UK-based clients',
            'Gained valuable international work experience and cross-cultural collaboration skills',
            'Designed and implemented both client-facing interfaces and administrative dashboards',
            'Technologies: JavaScript, Node.js, MongoDB, HTML5/CSS3, RESTful APIs'
        ],
        category: 'internship',
        image_url: null
    },
    {
        id: 7,
        title: 'Software Developer',
        isRemote: false,
        isHybrid: false,
        company: 'Adaptive / Connecting the traveller',
        location: 'Ramonville, France',
        startDate: '2018-06',
        endDate: '2018-09',
        description: 'Full-time position continuing previous internship work on travel industry applications.',
        skills: [
            'Developed comprehensive content management ecosystem for travel industry with supervision tools and administrative interfaces',
            'Engineered robust event logging system enabling real-time monitoring of critical user experience',
            'Improved application performance through database optimization and caching strategies',
            'Collaborated with product team to identify and implement system improvements and new features',
            'Technologies: Python, Django, PostgreSQL, RESTful APIs'
        ],
        category: 'work',
        image_url: 'https://pbs.twimg.com/profile_images/675349671875731457/lzC-QiY7_400x400.png'
    },
    {
        id: 8,
        title: 'Software Developer - Intern',
        isRemote: false,
        isHybrid: false,
        company: 'Adaptive / Connecting the traveller',
        location: 'Ramonville, France',
        startDate: '2018-01',
        endDate: '2018-05',
        description: 'Internship focusing on content management systems for the travel industry.',
        skills: [
            'Architected and developed comprehensive content management ecosystem for travel industry application',
            'Built supervision tools and administrative interfaces improving operational efficiency',
            'Engineered robust event logging system that improved debugging efficiency and enabled real-time monitoring',
            'Collaborated with product team to identify optimization opportunities',
            'Technologies: Python, Django, PostgreSQL, RESTful APIs, event-driven architecture'
        ],
        category: 'internship',
        image_url: 'https://pbs.twimg.com/profile_images/675349671875731457/lzC-QiY7_400x400.png'
    },
    {
        id: 9,
        title: 'Web Developer - Intern',
        isRemote: false,
        isHybrid: false,
        company: 'Atida | Santédiscount',
        location: 'Montrabé, France',
        startDate: '2017-04',
        endDate: '2017-07',
        description: 'Internship in healthcare e-commerce focusing on automated systems and database management.',
        skills: [
            'Engineered automated website generation system with AWS integration',
            'Built database management system for pharmaceutical data processing and analytics',
            'Implemented JEKYLL framework for efficient static site generation',
            'Technologies: Jekyll, AWS, Database Management, Automation'
        ],
        category: 'internship',
        image_url: 'https://i.pinimg.com/280x280_RS/e8/be/6b/e8be6b6344e8b2b7517f069ce5d64d44.jpg'
    },
    {
        id: 10,
        title: 'Web Developer - Intern',
        isRemote: false,
        isHybrid: false,
        company: 'CNRS',
        location: 'Labège, France',
        startDate: '2016-09',
        endDate: '2016-12',
        description: 'Internship at France\'s National Scientific Research Center developing monitoring systems.',
        skills: [
            'Designed and developed enterprise-grade "Service Health Dashboard" from scratch for France\'s National Scientific Research Center',
            'Implemented MongoDB database solution for real-time system monitoring and alerting',
            'Created visualization components that provided critical operational intelligence for IT operations team',
            'Technologies: MongoDB, Dashboard Development, System Monitoring, Data Visualization'
        ],
        category: 'internship',
        image_url: 'https://www.science-diplomacy.eu/media/cnrs-logo.jpg'
    },
];

export default timelineData;
